import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useSpinnerStore = defineStore('retailSpinnerStore', () => {
  const isSpinnerOpened = ref(false)

  const showSpinner = () => {
    isSpinnerOpened.value = true
  }

  const closeSpinner = () => {
    isSpinnerOpened.value = false
  }

  return {
    isSpinnerOpened,
    showSpinner,
    closeSpinner
  }
})
